export const LOADING_FILL_COLOR = Styles.color.white;
